/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2022 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import classNames from 'classnames';
import React from 'react';

import { injectIntl } from '@nebula/izzy/intl';
import Loading from '@nebula/luna/dist/core/loading-scrim';
import styles from './styles/casing.styl';

const Casing = ({
  children,
  loaded,
  procLoading = false
}) => (
  loaded
    ? (
      <div>
        <div>
          {children}
        </div>
        {procLoading && <Loading scrim />}
      </div>
    )
    : (
      <div>
        <Loading scrim={false} />
      </div>
    )
);

const GeminiCasing = ({
  children,
  ...props
}) => (
  <Casing
    {...props}
  >
    <div
      className={classNames(styles.contentArea, styles.unified)}
    >
      {children}
    </div>
  </Casing>
);

GeminiCasing.displayName = 'GeminiCasing';

export default injectIntl(GeminiCasing);
